import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IEmployeesDataState } from './types/employees-data-state';
import { IWorkingTimeRegulation } from './types/work-time-regulation.interface';
import { ICoreTimeRequest } from './types/core-time-request.interface';
import { EAppRoutes } from '../../enums/app-routes.enum';
import { IUser } from '../../types/user.interface';

export const employeeActions = createActionGroup({
  source: 'Employee',
  events: {
    'Fetch employees': emptyProps,
    'Success fetching employees': props<{
      payload: IEmployeesDataState;
    }>(),
    'Failed fetching employees': emptyProps,
    'Set current employee': props<{ payload: number | null }>(),
    'Set alias': props<{
      payload: { user: IUser; path: EAppRoutes | string };
    }>(),
    SetRedirectPath: props<{ payload: EAppRoutes }>(),
    RemoveRedirectPath: emptyProps,
    'Remove alias': emptyProps,
    'Fetch today': props<{ payload: Date }>(),
    'Set today': props<{ payload: Date }>(),
    SetCurrentYear: props<{ payload: number }>(),
    SetCalendarMonth: props<{ payload: number | null }>(),
    'Set Month Overview': props<{ payload: { month: number; year: number } }>(),
    'Set Employee Month': props<{ payload: number }>(),
    'Reset Month Overview': emptyProps,
    'Set Work Record': props<{ payload: number }>(),
    ChangeCoreTime: props<{ payload: ICoreTimeRequest }>(),
    ChangeCoreTimeSuccess: emptyProps,
    ChangeCoreTimeFailed: emptyProps,
    'Stop loading': emptyProps,
    Logout: emptyProps,
  },
});
